"use strict";
document.querySelector('html').classList.add('js')
document.querySelector('html').classList.remove('no-js')


document.querySelector('.header__navtoggler').addEventListener('click', () => {
  document.body.classList.toggle('body--activenav');
})


let setMenuLevel = (level) => {
  const menu = document.querySelector('.header__mainnav > ul');

  for (let clickedItem of document.querySelectorAll('.header__mainnav li.parent.clicked')) {
    clickedItem.classList.remove('clicked')
  }

  menu.setAttribute('class', menu.getAttribute('class').replace(/(nav--level\d)/, ''))
  menu.classList.add('nav--level' + level)

}

// Main menu behavior
for (let menuItem of document.querySelectorAll('.header__mainnav li.parent > a, .header__mainnav li.parent > span')) {
  if (window.innerWidth <= 1280) {
    menuItem.addEventListener('click', (e) => {
      const item = e.target;

      // Prevent link opening
      e.preventDefault()

      const parentClass = item.parentElement.parentElement.getAttribute('class')
      const parentLevel = parentClass.match(/list--level(\d)/)[1]

      setMenuLevel(parseInt(parentLevel) + 1)

      item.parentElement.classList.add('clicked')

      if (item.parentElement.parentElement.parentElement.classList.contains('parent')) {
        item.parentElement.parentElement.parentElement.classList.add('clicked')
      }
    });
  } 
}


for (let menuItem of document.querySelectorAll('.header__mainnav button.mainnav__backlink')) {
  if (window.innerWidth <= 1280) {
    menuItem.addEventListener('click', (e) => {
      e.preventDefault()

      const parentClass = e.target.parentElement.parentElement.getAttribute('class')
      const parentLevel = parentClass.match(/list--level(\d)/)[1]

      setMenuLevel(parseInt(parentLevel) - 1)

      e.target.parentElement.parentElement.parentElement.classList.add('clicked')

      if (e.target.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains('parent')) {
        e.target.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add('clicked')
      }
    });
  }
}


// Header-Animation

window.addEventListener('scroll', () => {
  if(window.scrollY > 0) {
    document.querySelector('header').classList.add('body--scrolled')
  } else {
    document.querySelector('header').classList.remove('body--scrolled')
  }
})